var module = angular.module('octopusApp.projects');

module.directive('azurePowershellScriptInfo', function () {
    return {
        restrict: 'E',
        replace: true,
        templateUrl:'areas/projects/views/azure_powershell_script_info.html'
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/azure_powershell_script_info.js
// module id = 8068119372681933
// module chunks = 1